// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateAwsSetting_createButton__2qIEq"};